module.exports = __webpack_public_path__ + "img/ecpm_map_icon.3b49c5f1.svg";